import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, Vector, ViewerObjectComponent } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range";
import { getViewerObject } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
export default class AdjustMountingRailModelParentSystem extends SystemBase {
    constructor(core, viewerCoreAdapter) {
        super(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
        this.core = core;
        this.viewerCoreAdapter = viewerCoreAdapter;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = 'AdjustMountingRailModelParentSystem';
        this.mandatoryComponents = [COMPONENT_IDS.MOUNTING_RAIL_COMPONENT];
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        const viewerObject = getViewerObject(_entity);
        const newViewerObject = this.viewerCoreAdapter.createEmpty(_entity);
        _entity.addComponent(new ViewerObjectComponent(newViewerObject));
        viewerObject.setParent(newViewerObject);
        viewerObject.setPosition(new Vector(0, 0, 0));
    }
}
